/* COVA cart: Ajax Cart API + Section Rendering API for the cart drawer, product card add buttons and option pills, quantity widgets */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    var CV = window.CV;
    if (CV.cartReady) return;
    CV.cartReady = true;
    var routes = window.cvRoutes || {};
    var drawerEl = function () { return document.getElementById('cv-cart-drawer'); };

    function request(url, body) {
      return fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    }

    function getCart() {
      return fetch((routes.root || '/') + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    var cart = CV.cart = {
      add: function (id, quantity) {
        return request((routes.cartAdd || '/cart/add') + '.js', { id: id, quantity: quantity || 1 });
      },
      change: function (key, quantity) {
        return request((routes.cartChange || '/cart/change') + '.js', { id: key, quantity: quantity });
      },
      note: function (note) { return request('/cart/update.js', { note: note }); },
      // re-render the drawer content from the server and refresh the counters in the header
      // skipProtect must be exactly true: render is also used as a bare .then() callback and then receives a cart object
      render: function (skipProtect) {
        var drawer = drawerEl();
        if (!drawer) return Promise.resolve();
        var id = drawer.getAttribute('data-section-id');
        drawer.classList.add('is-loading');
        // shipping protection is settled first, so the drawer is drawn once with the right lines
        var settle = skipProtect === true ? Promise.resolve() : getCart().then(protectFix);
        return settle.then(function () {
          var url = window.location.pathname + '?sections=' + encodeURIComponent(id);
          return fetch(url, { credentials: 'same-origin' });
        }).then(function (r) { return r.json(); }).then(function (data) {
          var doc = new DOMParser().parseFromString(data[id] || '', 'text/html');
          var body = doc.querySelector('[data-cv-cart-body]');
          var label = doc.querySelector('[data-cv-cart-count-label]');
          var current = drawer.querySelector('[data-cv-cart-body]');
          if (body && current) current.innerHTML = body.innerHTML;
          var lbl = drawer.querySelector('[data-cv-cart-count-label]');
          if (label && lbl) lbl.textContent = label.textContent;
          return getCart();
        }).then(function (c) {
          setCounters(c);
          drawer.classList.remove('is-loading');
          document.dispatchEvent(new CustomEvent('cv:cart:updated', { detail: c }));
        }).catch(function () { drawer.classList.remove('is-loading'); });
      },
      open: function () { var d = drawerEl(); if (d) CV.openDrawer(d); }
    };

    // open the drawer from anywhere
    document.addEventListener('cv:cart:open', function () { cart.render().then(cart.open); });

    // shipping protection: on by default. One line of the protection variant (data-protect-id on the drawer)
    // while the cart holds anything else; switching it off is remembered on the cart (attribute _cv_protection = off);
    // it never stays in a cart on its own. Header counters leave it out.
    var onCartPage = window.location.pathname === (routes.cart || '/cart');
    function protectId() { var d = drawerEl(); return d ? d.getAttribute('data-protect-id') : null; }
    function protectLine(c, pid) {
      var line = null, others = 0;
      (c.items || []).forEach(function (i) { if (String(i.variant_id) === String(pid)) line = i; else others += i.quantity; });
      return { line: line, others: others };
    }
    function setCounters(c) {
      var pid = protectId();
      var p = pid ? protectLine(c, pid) : null;
      var n = p ? p.others : c.item_count;
      document.querySelectorAll('[data-cv-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    }
    // returns a promise when the cart needed a change, or null when it is already right
    function protectFix(c) {
      var pid = protectId();
      if (!pid || !c) return null;
      var p = protectLine(c, pid);
      var off = c.attributes && c.attributes._cv_protection === 'off';
      var job = null;
      if (p.line && (!p.others || off)) job = cart.change(p.line.key, 0);
      else if (p.line && p.line.quantity > 1) job = cart.change(p.line.key, 1);
      else if (!p.line && p.others && !off) job = cart.add(pid, 1);
      return job ? job.catch(function (err) { if (window.console) console.error('[cv] shipping protection update failed', err); }) : null;
    }
    // the switch row
    document.addEventListener('change', function (e) {
      var sw = e.target.closest && e.target.closest('[data-cv-protect]');
      if (!sw) return;
      var on = sw.checked;
      var d = drawerEl();
      if (d) d.classList.add('is-loading');
      queue = queue.then(function () {
        return request('/cart/update.js', { attributes: { _cv_protection: on ? '' : 'off' } });
      }).then(function (c) { return protectFix(c); }).catch(function (err) {
        if (window.console) console.error('[cv] shipping protection switch failed', err);
      }).then(function () {
        if (onCartPage) { window.location.reload(); return; }
        return cart.render(true);
      });
    });
    // page load: settle the cart once (a cart filled elsewhere gets its protection line) and set the counters
    getCart().then(function (c) {
      setCounters(c);
      var fix = protectFix(c);
      if (!fix) return;
      return fix.then(function () {
        if (onCartPage) { window.location.reload(); return; }
        return cart.render(true);
      });
    }).catch(function () {});
    // cart page (Dawn): after its own quantity/remove updates, an emptied cart loses the protection line too,
    // and removing the protection line there counts as switching it off
    if (onCartPage && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        var pid = protectId();
        if (!pid) return;
        getCart().then(function (c) {
          var p = protectLine(c, pid);
          if (!p.line && p.others) return request('/cart/update.js', { attributes: { _cv_protection: 'off' } });
          var fix = protectFix(c);
          if (fix) return fix.then(function () { window.location.reload(); });
        }).catch(function () {});
      });
    }

    // add to cart (product cards, quick view)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('form[data-cv-add-form]');
      if (!form) return;
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput || !idInput.value) return;
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      cart.add(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1).then(function () {
        return cart.render();
      }).then(function () { cart.open(); }).catch(function (err) {
        if (window.console) console.error('[cv] add to cart failed', err);
      }).then(function () { if (btn) btn.disabled = false; });
    });

    // quantity widgets
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-cv-qty-minus]');
      var plus = e.target.closest('[data-cv-qty-plus]');
      if (!minus && !plus) return;
      var wrap = (minus || plus).closest('[data-cv-qty]');
      var input = wrap && wrap.querySelector('[data-cv-qty-input]');
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '0', 10);
      var v = (parseInt(input.value, 10) || 0) + (plus ? 1 : -1);
      input.value = Math.max(min, v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    // line changes run one at a time so fast clicks can't race or hit a line that just moved
    var queue = Promise.resolve();
    function changeLine(el, quantity) {
      var row = el.closest('[data-key]');
      if (!row) return;
      var key = row.getAttribute('data-key');
      drawerEl().classList.add('is-loading');
      queue = queue.then(function () { return cart.change(key, quantity); }).catch(function (err) {
        if (window.console) console.error('[cv] cart change failed', err);
      }).then(cart.render);
    }
    document.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('.cv-cart [data-cv-qty-input]');
      if (!input) return;
      changeLine(input, Math.max(0, parseInt(input.value, 10) || 0));
    });
    document.addEventListener('click', function (e) {
      var rm = e.target.closest('.cv-cart [data-cv-remove]');
      if (!rm) return;
      changeLine(rm, 0);
    });
    document.addEventListener('change', function (e) {
      var note = e.target.closest && e.target.closest('[data-cv-note]');
      if (note) cart.note(note.value);
    });

    // option pills on a product card: pick the variant for the cart button and show its price
    document.addEventListener('change', function (e) {
      var pill = e.target.closest && e.target.closest('[data-cv-options] input[type="radio"]');
      if (!pill) return;
      var card = pill.closest('[data-cv-pcard]');
      if (!card) return;
      var id = card.querySelector('[data-cv-variant-id]');
      if (id) id.value = pill.value;
      var now = card.querySelector('[data-cv-price-now]');
      if (now && pill.dataset.price) now.textContent = pill.dataset.price;
      var was = card.querySelector('[data-cv-price-was]');
      if (was) { was.textContent = pill.dataset.compare || ''; was.hidden = !pill.dataset.compare; }
    });
  });
})();
